import React from 'react';
import c from 'classnames';

import PublicationDate from './PublicationDate';
import ReadTime from './ReadTime';

import './style.scss';

interface ArticleMetadataSubComponents {
  PublicationDate: typeof PublicationDate;
  ReadTime: typeof ReadTime;
}

export interface ArticleMetadataProps {
  className?: string;
}

const ArticleMetadata: React.FC<ArticleMetadataProps> & ArticleMetadataSubComponents = (props) => {
  const {
    className,
    children,
  } = props;

  const classNames = c('ArticleMetadata', className);

  return (
    <div className={classNames}>
      {children}
    </div>
  );
};

ArticleMetadata.PublicationDate = PublicationDate;
ArticleMetadata.ReadTime = ReadTime;

export default ArticleMetadata;
